import { sendSumoLog } from './sumoLogger';

export const postDivisionSupervisor = async (
  lanId,
  division,
  token,
  dispatch
) => {
  const postURL = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/app-files/supervisor/`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });

  const body = JSON.stringify({ lanID: lanId, division: division });
  try {
    const data = await fetch(postURL, {
      method: 'POST',
      headers,
      body,
    });
    if (!data.ok) {
      const errorType = 'postDivision';
      const errorCode = data.status;
      const message = `post division supervisor ${lanId} ${division} failed`;
      sendSumoLog(errorType, message, errorCode, dispatch);
      return { error: errorCode };
    }
    return await data.json();
  } catch (error) {
    const message = `post division supervisor ${lanId} ${division} failed`;
    sendSumoLog(error, message, dispatch);
    return { error: error };
  }
};
